import { render, staticRenderFns } from "./NormalAchievement.vue?vue&type=template&id=4f8b4d41&scoped=true&"
import script from "./NormalAchievement.vue?vue&type=script&lang=js&"
export * from "./NormalAchievement.vue?vue&type=script&lang=js&"
import style0 from "./NormalAchievement.vue?vue&type=style&index=0&id=4f8b4d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b4d41",
  null
  
)

export default component.exports